<template>
  <div class="a-suggested-searches">
    <div class="a-suggested-searches__full-bleed-wrapper">
      <div class="a-suggested-searches__container">
        <div ref="heading" class="a-suggested-searches__heading">
          {{ heading }}
        </div>
        <div ref="subheading" class="a-suggested-searches__subheading">
          {{ subHeading }}
        </div>
      </div>
      <div class="a-suggested-searches__grid">
        <ImageAndCaption
          v-for="item in dataset"
          v-bind="{ ...item }"
          :key="item.id"
          data-testid="suggested-searches-item"
          :image-alt="item.imageAlt"
          :heading-level="3"
        >
        </ImageAndCaption>
      </div>
    </div>
  </div>
</template>

<script>
import { localizationMixin, ImageAndCaption } from "@thegetty-private/getty-ui";
import suggestedSearchesDataset from "@/data/suggestedSearchesDataset.json";

export default {
  name: "SuggestedSearches",
  components: {
    ImageAndCaption
  },
  mixins: [localizationMixin],
  props: {
    /**
     * Whether the search has results or not
     */
    hasResults: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * The search query terms
     */
    queryTerms: {
      type: Array,
      required: false,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      /**
       * Return the heading for a blank search
       */
      blankSearchHeading: this.translatePart(
        "search.suggested_searches.blank_search_heading"
      ),
      /**
       * Return the sub-heading
       */
      subHeading: this.translatePart("search.suggested_searches.subheading"),
      /**
       * The JSON data objects used to populate the suggested searches
       */
      dataset: []
    };
  },
  computed: {
    /**
     * Chooses the heading based on the presence of query
     */
    heading() {
      if (this.hasResults == false) {
        return this.noResultsHeading;
      } else {
        return this.blankSearchHeading;
      }
    },
    /**
     * Return the heading for no search results
     */
    noResultsHeading() {
      if (this.queryTerms.length == 0) {
        return this.translatePart(
          "search.suggested_searches.no_results_heading_no_query_terms"
        );
      }

      return this.translatePart(
        "search.suggested_searches.no_results_heading",
        { search: this.queryTerms.join(", ") }
      );
    }
  },

  beforeMount() {
    /**
     * Set the dataset from our JSON file
     */
    this.dataset = suggestedSearchesDataset.map((item) => {
      item.heading = this.translatePart("search.suggested_searches." + item.id);
      item.to.state = { scrollToTop: true };
      return item;
    });
  }
};
</script>

<style lang="scss">
@import "./index";
</style>
